<template>
  <layout-main-inner title="新建批次">
    <div slot="action">
      <el-button
        v-if="step === 1"
        type="primary"
        @click="nextStep">下一步</el-button>
      <el-button
        v-if="step === 2"
        @click="prevStep">上一步</el-button>
      <el-button
        v-if="step === 2"
        type="primary"
        @click="save">保存</el-button>
    </div>
    <product-select-table
      v-show="step === 1"
      ref="selectTable" />
    <div v-show="step === 2">
      <product-info
        :loading="loading"
        :product="product" />

      <batch-form-dz
        v-if="product.tagType === 1"
        ref="form"
        :loading="loading"
        :batch="batchInfo"
        :productId="product.productId"
        :tradeType="product.tradeType"
        :vendorId="+$route.query.vendorId" />

      <batch-form-pm
        v-if="product.tagType !== 1 && $route.query.tagModel === '1' && product.codingType === 1 "
        ref="form"
        :loading="loading"
        :batch="batchInfo"
        :productId="product.productId"
        :tradeType="product.tradeType"
        :tagType="product.tagType"
        :vendorId="+$route.query.vendorId" />

      <batch-form-pm-no-tag
        v-if="product.tagType !== 1 && $route.query.tagModel === '1' && product.codingType === 9 "
        ref="form"
        :loading="loading"
        :batch="batchInfo"
        :productId="product.productId"
        :tradeType="product.tradeType"
        :tagType="product.tagType"
        :vendorId="+$route.query.vendorId" />

      <batch-form-pm-ck
        v-if="product.tagType !== 1 && $route.query.tagModel === '1' && product.codingType === 2 "
        ref="form"
        :loading="loading"
        :batch="batchInfo"
        :productId="product.productId"
        :tradeType="product.tradeType"
        :tagType="product.tagType"
        :vendorId="+$route.query.vendorId" />

      <batch-form-tm
        v-if="product.tagType !== 1 && $route.query.tagModel === '2' && product.codingType === 1 "
        ref="form"
        :loading="loading"
        :batch="batchInfo"
        :productId="product.productId"
        :tradeType="product.tradeType"
        :tagType="product.tagType"
        :vendorId="+$route.query.vendorId" />

      <batch-form-tm-ck
        v-if="product.tagType !== 1 && $route.query.tagModel === '2' && product.codingType === 2 "
        ref="form"
        :loading="loading"
        :batch="batchInfo"
        :productId="product.productId"
        :tradeType="product.tradeType"
        :tagType="product.tagType"
        :vendorId="+$route.query.vendorId" />
    </div>
    <template slot="footer">
      <!-- <back-button ref="back" /> -->
      <!-- <el-button
        v-if="step === 1"
        type="primary"
        @click="nextStep">下一步</el-button>
      <el-button
        v-if="step === 2"
        @click="prevStep">上一步</el-button>
      <el-button
        v-if="step === 2"
        type="primary"
        @click="save">保存</el-button> -->
    </template>
  </layout-main-inner>
</template>

<script>
import ProductSelectTable from './busi/product-select-table.vue'
import ProductInfo from './busi/product-info.vue'
import batchFormDz from './busi/batch-form-dz.vue'
import batchFormPm from './busi/batch-form-pm.vue'
import batchFormPmNoTag from './busi/batch-form-pm-no-tag.vue'
import batchFormTm from './busi/batch-form-tm.vue'
import batchFormPmCk from './busi/batch-form-pm-ck.vue'
import batchFormTmCk from './busi/batch-form-tm-ck.vue'
import '@/components/business/custom-form/index'
// import Utils from './busi/utils.js'
import TemplateFormat from '@/utils/templateFormat'

// import clonedeep from 'lodash.clonedeep'
export default {
  name: 'BatchCreate',
  components: { ProductSelectTable, ProductInfo, batchFormDz, batchFormPm, batchFormPmNoTag, batchFormTm, batchFormPmCk, batchFormTmCk },
  props: {},
  data() {
    return {
      step: 1,
      loading: false,
      product: {},
      batchInfo: {
        baseFields: [],
        extraFields: []
      }
    }
  },
  created() { },
  mounted() { },
  methods: {
    prevStep() {
      this.$confirm('数据暂未保存，是否重新选择商品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.step = 1
        })
    },
    nextStep() {
      const current = this.$refs.selectTable.getCurrent()
      console.log(current)
      if (!current) {
        this.$message.error('请先选择商品')
        return
      }
      this.product = current
      this.getcategorytemplate({
        classId: current.categoryId,
        tradeType: current.tradeType
      }, () => {
        this.step = 2
      })
    },
    getcategorytemplate(config, cb) {
      this.loading = true
      this.$store.dispatch('industry/getcategorytemplate', {
        payload: config,
        success: (res) => {
          this.loading = false
          const batchBaseTemplate = TemplateFormat.newTemplateFormat(res.data.batchBaseTemplate)
          const batchExtraTemplate = TemplateFormat.newTemplateFormat(res.data.batchExtraTemplate || [])
          this.batchInfo.baseFields = batchBaseTemplate
          this.batchInfo.extraFields = batchExtraTemplate
          cb && cb()
        },
        fail: () => {
          this.loading = false
          this.batchInfo.baseFields = []
          this.batchInfo.extraFields = []
        }
      })
    },
    save() {
      this.$refs.form.submit((res) => {
        this.loading = true
        const postdata = {
          warehouseId: this.$route.query.warehouseId,
          vendorId: this.$route.query.vendorId,
          productId: this.product.productId,
          tagModel: this.$route.query.tagModel,
          needSyncInventory: this.$route.query.needSyncInventory,
          codingType: this.product.codingType,
          isContinous: 1,
          ...res
        }
        this.$store.dispatch('batch/addbatch', {
          payload: postdata,
          success: () => {
            this.loading = false
            this.$router.go(-1)
            // this.$refs.back.back()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    }
  }
}
</script>
<style lang="stylus"></style>
